import React from "react";

import Label from "@busbud/design-system-components/dist/Label";
import LayoutSection from "@busbud/design-system-components/dist/Layout/LayoutSection";
import Stack from "@busbud/design-system-components/dist/Stack";

import { useNavigation } from "@app/modules/results/hooks/use-navigation";
import { useStyles } from "@app/modules/ticket-options/ticket-options.styles";
import type { TripOption, TripOptionsMatrix } from "@app/types/results-types";
import type { SearchInfo } from "@app/types/search-types";

import { Summary } from "./summary";

interface Props {
  disabled: boolean;
  is_external?: boolean;
  onClickContinue: (trip_option: TripOption) => void;
  search: SearchInfo;
  segment_id?: string;
  selected_trip?: TripOption;
  step_label: string;
  trip_options_matrix: TripOptionsMatrix;
}

export const NavigationWrapperLayout: React.FC<
  React.PropsWithChildren<Props>
> = ({
  children,
  disabled,
  is_external,
  onClickContinue,
  search,
  selected_trip,
  segment_id,
  step_label,
  trip_options_matrix
}) => {
  const { classes } = useStyles();
  const { is_roundtrip } = useNavigation();

  return (
    <>
      <LayoutSection className={classes.toolbar} yMargin={{ xs: 2, lg: 3 }}>
        <Stack
          justifyContent="space-between"
          alignItems="center"
          ml={2}
          flexWrap="wrap"
          spacing={1}
        >
          <Label size={{ xs: "xl", md: "xxl" }} fontWeight="heavy">
            {step_label}
          </Label>
          <Summary
            disabled={disabled}
            is_external={is_external}
            is_roundtrip={is_roundtrip}
            onClickContinue={onClickContinue}
            search={search}
            segment_id={segment_id}
            selected_trip={selected_trip}
            trip_options_matrix={trip_options_matrix}
          />
        </Stack>
      </LayoutSection>
      {children}
      <LayoutSection fullWidth={true} yMargin={{ xs: 2, lg: 3 }}>
        <Summary
          disabled={disabled}
          is_external={is_external}
          is_roundtrip={is_roundtrip}
          onClickContinue={onClickContinue}
          search={search}
          selected_trip={selected_trip}
          segment_id={segment_id}
          trip_options_matrix={trip_options_matrix}
        />
      </LayoutSection>
    </>
  );
};

// Necessary to the price and other info be properly updated using passenger selector counter if is the case.
export const patchSearchAdultWithSelectedSeats = (
  search: SearchInfo,
  selected_seats: number
) => {
  return {
    ...search,
    adult: selected_seats > search.adult ? selected_seats : search.adult
  };
};
